// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"260":"ba00f43230b327e9","296":"44ce7d5addefe3ff"}[chunkId] + ".js";
};